<template>
  <my-view></my-view>
</template>

<script>
import MyView from "@/pages/publicView/personalCenter/index_view.vue";

export default {
  components: { MyView },
};
</script>